module.exports = __webpack_public_path__ + "static/media/logofarma.4756254b.png";